<script lang="ts">
	import { Button, type ButtonProps } from '#lib/components/ui/button/index.js';
	import { fly, slide } from 'svelte/transition';
	import { LoaderCircle } from '@lucide/svelte';

	type Props = {
		isLoading?: boolean;
		children?: () => any;
	};

	const { isLoading, children, ...restProps }: Props & ButtonProps = $props();
	let container: HTMLDivElement;
</script>

<div bind:this={container}>
	<Button {...restProps}>
		{#if isLoading}
			<div in:slide={{ axis: 'x', duration: 400 }} out:slide={{ axis: 'x', duration: 400 }}>
				<div in:fly={{ x: -50, duration: 400 }} out:fly={{ x: -50, duration: 500 }}>
					<LoaderCircle data-testid="loading-icon" class="animate-spin size-4 me-2" />
				</div>
			</div>
		{/if}
		{@render children?.()}
	</Button>
</div>
